import { Card, Typography } from "antd";
import React from "react";
import JsonView from "react18-json-view";
import 'react18-json-view/src/style.css'

const { Text } = Typography;

const JobDocumentViewer = ({ onGoingExecution, jobDocument }) => {
  return Object.keys(onGoingExecution).length > 0 && <>
    <Card style={{ marginBottom: '4%', marginTop: '4%' }}>
      <Text>Job Document</Text>
      <JsonView src={jobDocument} />
    </Card >
  </>
}

export default JobDocumentViewer;